import { useNavigate } from "react-router-dom";
import * as cs from "../../SignCommonStyled";
import React, { useCallback } from "react";
import { IoWarningOutline } from "react-icons/io5";

interface Props {
  validateMsg: string;
}

export default function ExpiredToken(props: Props): JSX.Element {
  const navigate = useNavigate();

  const onClickBackLogin = useCallback(() => {
    navigate("/login");
  }, []);

  return (
    <>
      <cs.ExpiredWrapper>
        <IoWarningOutline size={30} />
        <div>Invitation has expired.</div>
        <span>Please contact your administrator.</span>
      </cs.ExpiredWrapper>

      <cs.BigButton
        id="dw_signup_button_forward_login"
        type="button"
        onClick={onClickBackLogin}
      >
        Return to Login Screen
      </cs.BigButton>
    </>
  );
}
